function initFaqAccordion(root) {
  if (!root || root.dataset.faqInitialized === 'true') return;
  root.dataset.faqInitialized = 'true';

  const allowMultiple = root.dataset.allowMultiple === 'true';
  const triggers = root.querySelectorAll('.faq-accordion__trigger');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = root.querySelector('#' + panelId);
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (!allowMultiple) {
        triggers.forEach(function (otherTrigger) {
          if (otherTrigger !== trigger) {
            const otherPanelId = otherTrigger.getAttribute('aria-controls');
            const otherPanel = root.querySelector('#' + otherPanelId);
            otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.setAttribute('hidden', '');
          }
        });
      }

      trigger.setAttribute('aria-expanded', String(!isOpen));
      if (panel) {
        if (isOpen) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
        }
      }
    });
  });
}

document.querySelectorAll('.faq-accordion').forEach(initFaqAccordion);

// Re-initialize when the section is added/reloaded in the Shopify Theme Editor
document.addEventListener('shopify:section:load', function (event) {
  const section = event.target.querySelector('.faq-accordion');
  if (section) initFaqAccordion(section);
});